import { connect } from "react-redux";
import TeeSheetCheckIn from "pages/secure/facility/settings/teesheets/checkInConfig/TeeSheetCheckIn";
import { bindActionCreators } from "redux";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

const mapStateToProps = (state: any) => {
  return {
    uiStore: { ...state.uiStore },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TeeSheetCheckIn);
